import SwapVertIcon from '@mui/icons-material/SwapVert';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import type { ReactElement } from 'react';

export type SortFilterOption = {
    label: string;
    value: string;
};

export type SortFilterProps = {
    label: string;
    options: SortFilterOption[];
    value?: string;
    onChange?: (value: string) => void;
    fullWidth?: boolean;
};

export function SortFilter({ label, options, value = '', onChange, fullWidth = false }: SortFilterProps): ReactElement {
    return (
        <FormControl size="small" fullWidth={fullWidth}>
            <InputLabel>{label}</InputLabel>
            <Select
                label={label}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                startAdornment={
                    <InputAdornment position="start">
                        <SwapVertIcon />
                    </InputAdornment>
                }>
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
